module.exports = __webpack_public_path__ + "static/img/exhibitFormTips4.af059dec.png";